<template>
  <el-dialog
    class="detail refund-dialog"
    title="发起退款"
    :visible.sync="showRefundDialog"
    width="980px"
  >
    <p v-if="current == 6">请选择需要退款的课时：</p>
    <p v-else>请选择需要退款的课程：</p>
    <el-table
      class="table-refund"
      @selection-change="handleSelectionChange"
      :data="tableData"
      border
      style="margin: 10px 0"
    >
      <el-table-column
        align="center"
        :selectable="selectable"
        type="selection"
        width="60"
        v-if="current != 6"
      ></el-table-column>
      <el-table-column
        prop="shop_name"
        label="商品名称"
        class-name="column-shop_name"
      ></el-table-column>
      <template v-if="current == 6">
        <el-table-column
          prop="can_refund_num"
          label="可退课时数"
          width="115"
        ></el-table-column>
        <el-table-column label="退款课时" width="160">
          <template v-slot="{ row }">
            <div @click.stop>
              <el-input-number
                class="refund-periods_num"
                v-model="refundNum[row.id]"
                :min="0"
                :max="row.can_refund_num"
              ></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="退款金额" width="130">
          <template v-slot="{ row }">
            <Currency></Currency>
            <span>{{ getItemRefundPrice(row) }}</span>
          </template>
        </el-table-column>
      </template>
      <template v-else>
        <el-table-column prop="price" label="商品原价" width="180">
          <template slot-scope="scope">
            <p class="price-box">
              <Currency :price="scope.row.price"></Currency>
              {{ scope.row.price }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          v-if="detail.order_type == 7"
          prop="discount_price"
          label="联报优惠"
          width="100"
        >
          <template slot-scope="scope">
            <p class="price-box">
              <Currency :price="scope.row.discount_price"></Currency>
              {{ scope.row.discount_price }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="coupon_price" label="优惠券优惠" width="130">
          <template slot-scope="scope">
            <p class="price-box">
              <Currency :price="scope.row.coupon_price"></Currency>
              {{ scope.row.coupon_price }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="paid_price" label="实际支付" width="100">
          <template slot-scope="scope">
            <p class="price-box">
              <Currency :price="scope.row.paid_price"></Currency>
              {{ scope.row.paid_price }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="shop_status_name"
          label="状态"
          width="120"
        ></el-table-column>
      </template>
    </el-table>
    <p class="refund-total">
      <span class="refund-total_label">退款金额：</span>
      <span class="refund-total_price">
        <Currency></Currency>
        <span>{{ refundPrice }}</span>
      </span>
    </p>
    <p class="color-6" style="margin: 10px 0">退款原因</p>
    <div>
      <el-input
        type="textarea"
        :rows="5"
        :maxlength="100"
        v-model="refundText"
      ></el-input>
      <div class="refund-count">{{ refundText.length }}/100</div>
    </div>
    <div class="refund-tip">申请退款及退款金额需要管理员审核，确认退款吗？</div>
    <div slot="footer" class="dialog-footer">
      <el-button type="default" @click="showRefundDialog = false">
        取消
      </el-button>
      <el-button @click="handleSubmitRefund" type="primary">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { ShopStatus } from "@/utils/enums.js";

export default {
  name: "MemberOrderRefund",
  props: ["current"],
  data() {
    return {
      showRefundDialog: false,
      selectItem: [],
      refundText: "",
      detail: {},
      tableData: [],
      refundNum: {},
    };
  },
  computed: {
    refundPrice() {
      let sum = 0;
      if (this.current == 6) {
        // this.tableData.forEach(row => {
        //   sum += row.fact_price * this.refundNum[row.id];
        // });
        // sum = sum / 100;
        sum = this.tableData.reduce((pre, cur) => {
          return pre + this.getItemRefundPrice(cur);
        }, 0);
      } else {
        this.selectItem.forEach(i => {
          sum += Number(i.paid_price);
        });
      }
      return sum;
    },
  },
  methods: {
    getItemRefundPrice(item) {
      const refundNum = this.refundNum[item.id] || 0;
      if (
        item.can_refund_num !== 0 &&
        item.can_refund_num === item.product_number &&
        refundNum === item.product_number
      ) {
        return +item.paid_price;
      }
      return refundNum * +item.fact_price;
    },
    selectable(row) {
      if (row.shop_status == 5) {
        return false;
      } else {
        return true;
      }
    },
    async applyRefund(item) {
      this.tempOrderId = item.id;
      this.$http
        .post("/api/app/myOrder/detail", {
          order_id: item.id,
        })
        .then(res => {
          this.detail = res;
          let refundNum = {};
          let tableData = res.items;
          tableData.forEach(i => {
            refundNum[i.id] = 0;
            i.price = this.$pub.calcPrice(i.price);
            i.discount_price = this.$pub.calcPrice(i.discount_price);
            i.coupon_price = this.$pub.calcPrice(i.coupon_price);
            i.paid_price = this.$pub.calcPrice(i.paid_price);
            i.fact_price = this.$pub.calcPrice(i.fact_price);
            i.shop_status_name = ShopStatus.getValue(i.shop_status);
          });
          this.tableData = tableData;
          this.showRefundDialog = true;
          this.refundNum = refundNum;
          this.selectItem = [];
          this.refundText = "";
        });
    },
    handleSelectionChange(selection) {
      this.selectItem = selection;
    },
    handleSubmitRefund() {
      let items = [];
      if (this.current == 6) {
        for (let key in this.refundNum) {
          let num = this.refundNum[key];
          if (num > 0) {
            items.push({
              order_item_id: key,
              refund_num: num,
            });
          }
        }
      } else {
        items = this.selectItem.map(t => {
          return {
            order_item_id: t.id,
            refund_num: t.product_number || 1,
          };
        });
      }
      if (items.length == 0) {
        if (this.current == 6) {
          this.$message.error("请至少选择一个课时");
        } else if (this.current == 4) {
          this.$message.error("请至少选择一个商品");
        } else {
          this.$message.error("请至少选择一门课程");
        }
        return;
      }
      this.$http
        .get(`/api/app/myOrder/application/${this.tempOrderId}`, {
          items: JSON.stringify(items),
          reason: this.refundText,
        })
        .then(() => {
          this.$message.success("操作成功");
          this.showRefundDialog = false;
          this.selectItem = [];
          this.refundText = "";
          this.$emit("refund");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../css/member-order.scss";
.price-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.refund-total {
  font-size: 14px;
  text-align: right;
  font-family: PingFang SC Medium, PingFang SC Medium-Medium;
  font-weight: 500;
}
.refund-total_price {
  color: #ff2d28;
}
.refund-dialog {
  /deep/ {
    .el-button {
      width: 94px;
      height: 36px;
      line-height: 36px;
      padding: 0;
    }
    .el-button--default {
      background: white !important;
      border: 1px solid #dcdfe6 !important;
      color: #333 !important;
    }
  }
}
.refund-tip {
  color: #333333;
  padding: 0 0 24px 0;
  line-height: 1;
}
.refund-count {
  text-align: right;
  color: #999999;
  margin: 8px 0 0 0;
  line-height: 1;
}
.refund-periods_num {
  line-height: 30px;
  width: 120px;
  /deep/ {
    .el-input-number__decrease,
    .el-input-number__increase {
      width: 30px;
      box-sizing: border-box;
    }
    .el-input__inner {
      height: 32px;
      line-height: 32px;
      padding: 0 40px;
    }
  }
}
.table-refund {
  /deep/ {
    th .cell,
    td .cell {
      padding: 0 20px !important;
    }
  }
}
</style>
